export type Rgb = readonly [r: number, g: number, b: number];

export function Rgb(...rgb: Rgb): Rgb {
  return rgb;
}

export namespace Rgb {
  export const black = Rgb(0, 0, 0);
  export const white = Rgb(255, 255, 255);
  export const blue = Rgb(0, 95, 175);
  export const blueDark = Rgb(6, 69, 119);
  export const blueBright = Rgb(28, 97, 240);
  export const blueLight = Rgb(206, 221, 254);
  export const pink = Rgb(244, 115, 170);
  export const pinkDark = Rgb(72, 2, 32);
  export const lavender = Rgb(207, 194, 222);
  export const purple = Rgb(86, 74, 99);
  export const plum = Rgb(149, 65, 110);
  export const rose = Rgb(235, 207, 222);
  export const red = Rgb(231, 30, 56);
  export const orange = Rgb(255, 85, 2);
  export const brown = Rgb(73, 60, 42);
  export const brownDark = Rgb(66, 48, 3);
  export const teal = Rgb(42, 120, 84);
  export const greenDark = Rgb(25, 32, 4);
  export const mint = Rgb(224, 255, 239);
  export const lime = Rgb(233, 255, 161);
  export const peach = Rgb(255, 239, 224);
  export const cream = Rgb(255, 228, 161);

  export namespace Status {
    export const success = Rgb(0, 175, 0);
    export const warning = Rgb(255, 200, 0);
    export const error = Rgb(220, 20, 60);
    export const verbose = Rgb(135, 135, 135);
    export const verboseLabelText = Rgb(94, 94, 94);
  }

  export namespace Variant {
    export function make(rgb: Rgb) {
      const [r, g, b] = rgb;
      const adjustValue = isDark(rgb) ? Variant.brighten : Variant.darken;

      return Rgb(adjustValue(r), adjustValue(g), adjustValue(b));
    }

    export function brighten(rgbColorValue: number) {
      return Math.min(255, rgbColorValue + 30);
    }

    export function darken(rgbColorValue: number) {
      return Math.max(0, rgbColorValue - 30);
    }
  }

  export function isDark(rgb: Rgb) {
    const sum = rgb.reduce(isDark.sum);
    return sum < isDark.MIDDLE_VALUE;
  }

  export namespace isDark {
    export const MIDDLE_VALUE = (255 * 3) / 2;

    export function sum(sum: number, current: number) {
      return sum + current;
    }
  }
}
